module.exports = __webpack_public_path__ + "img/pin_red.0e64dfc5.svg";